import { render } from "./Sala.vue?vue&type=template&id=3c00c950&scoped=true"
import script from "./Sala.vue?vue&type=script&lang=js"
export * from "./Sala.vue?vue&type=script&lang=js"

import "./Sala.vue?vue&type=style&index=0&id=3c00c950&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c00c950"]])

export default __exports__